import React, { Component } from 'react';

import { History as history, Routes as routes } from '../navigation';
import '../css/UserProfile.css';

class StartConsultation extends Component {

  constructor(props) {
    super(props);
    this.state = {

    }
  }

  renderStartConsultationSection = () => {


    return <div className="basic-container">
        <h4 style={{ }}>Start Consultation</h4>
        <div style={{ color: 'grey', marginTop: 10, marginBottom: 10 }}>
          Start a Consultation with one of your Clients
        </div>
        <div className='flex-container-row' style={{ justifyContent: 'flex-end' }}>
          <input  className='button-default'
                  value='Start Consultation'
                  type='submit'
                  onClick={ () => {
                    history.push(routes.CONSULTATION_START);
                  }}
          />
        </div>
    </div>
  }

  render() {
    return this.renderStartConsultationSection();
  }

}


export default StartConsultation
